import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import { keyframes, styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import LoadingButton from "_shared/_views/loading/loading-button";

export const pulse = keyframes`
  0% {
    transform: scale(0.9);
    opacity: 0.85;
  }
  50% {
    transform: scale(1.2);
    opacity: 1.0;
  }
  100% {
    transform: scale(0.9);
    opacity: 0.85;
  }
`;

export const Header = styled("section")(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  paddingBottom: theme.spacing(1),
  position: "sticky",
  top: "0px",
  zIndex: 10,
}));

export const TabsContainer = styled(Tabs)(({ theme }) => ({
  "&.MuiTabs-root": {
    overflow: "hidden",
    "& .MuiTabs-scroller": {
      paddingTop: theme.spacing(0.5),
    },
  },
}));

export const Content = styled("section")(() => ({
  alignItems: "center",
  display: "contents",
  flex: 1,
  flexDirection: "row",
  height: '100%',
  minHeight: "25rem",
  width: "100%",
}));

export const TabContent = styled("section")(({ theme }) => ({
  alignItems: "stretch",
  flexDirection: "column",
  display: "flex",
  flex: 1,
  margin: theme.spacing(2, 0),
  overflow: "visible",
  width: "100%",
}));

export const ActionsContainer = styled("section")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  backgroundColor: theme.palette.background.default,
  bottom: "0px",
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  paddingBottom: theme.spacing(2.5),
  position: "sticky",
  width: "100%",
  zIndex: 10,
}));

export const ProposalActions = styled("section")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    flexWrap: "nowrap",
  },
  alignContent: "end",
  alignItems: "center",
  display: "grid",
  flex: 1,
  gridTemplateColumns: "repeat(auto-fit, minmax(16rem, 1fr))",
  gap: theme.spacing(1),
  minHeight: "64px",
  width: '100%',
  '& > span': {
    width: '100%'
  }
}));

export const ReviewerBadge = styled(Badge)(() => ({
  marginLeft: "1rem",
}));

export const CommentButton = styled("section")(() => ({
  alignContent: "center",
  justifyContent: "flex-end",
}));

export const ButtonContainer = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  marginBottom: theme.spacing(2)
}));

export const HighlightCommentButton = styled(IconButton, { shouldForwardProp: (prop) => prop !== "active" })<{
  active?: boolean;
}>(({ active }) => ({
  paddingBottom: 0,
  position: "relative",
  zIndex: 0,
  ...(active && {
    animation: `${pulse} 1.5s ease-in-out infinite`,
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(21, 101, 192, 0.05)",
      borderRadius: "50%",
      animation: `${pulse} 1.5s ease-in-out infinite`,
      zIndex: -1,
    },
  }),
}));

export const CommentButtonLabel = styled(Typography)(() => ({
  fontSize: "0.6em",
}));

export const Fieldset = styled("span")(({ theme }) => ({
  border: "1px solid",
  borderColor: theme.palette.divider,
  borderRadius: theme.shape.borderRadius,
  display: "grid",
  gap: theme.spacing(1),
  gridColumnEnd: "span 2",
  gridTemplateColumns: "repeat(auto-fit, minmax(15rem, 1fr))",
  padding: theme.spacing(1),
  width: "100%",
}));

export const ProposalActionButton = styled(LoadingButton)(({ theme }) => ({
  minWidth: theme.spacing(24),
  whiteSpace: "nowrap",
  width: "100%",
  "&.Mui-disabled": {
    color: "rgba(0, 0, 0, 0.26) !important",
    backgroundColor: "rgba(0, 0, 0, 0.12) !important",
  },
}));
